<template>
  <div class="sort">
      <div v-for = "(col, index) in sortColumns" 
        :key="index"
        class="sort__item"
        @click = "this.sortData(index)"
      >
          <span class="sort__name">{{col.text}}</span>
          <!-- <img src="@/assets/img/icons/sort.svg" alt="" width="32" height="32"> -->
          <svg 
            :class="col.active && !col.asc ? 'img__sort--reverse' : ''" 
            width="32" height="32" 
            viewBox="0 0 32 32" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="32" rx="8" fill="white"/>
            <path 
              :class="col.active ? 'img__sort--active' : ''" 
              fill-rule="evenodd" clip-rule="evenodd" 
              d="M17.707 18.293L17 19L20 22L23 19L22.293 18.293L20.5 20.086V10H19.5V20.086L17.707 18.293ZM9 11H16V12H9V11ZM16 14H11V15H16V14ZM13 17H16V18H13V17Z" 
              fill="#1D4ED8"
            />
          </svg>
      </div>
      <div class="sort__item">
          <span class="sort__name">Код решения</span>
      </div>
      <div v-if="this.user?.ed_msg_enabled" class="sort__item">
          PDF
      </div>
      <div class="sort__item">
          Журн. сообщ.
      </div>
  </div>  
</template>

<script>
import { mapActions, mapState } from 'vuex';
//sortList
  export default {
    name: "ListDTSort",
    data: () => ({
      sortColumns: [
        {
          fieldName: 'regno',
          text: 'Регистрационный номер',
          active: false,
          asc: true
        },
        {
          fieldName: 'declarant',
          text: 'Декларант',
          active: false,
          asc: true
        },
        {
          fieldName: 'statuses',
          text: 'Статус',
          active: false,
          asc: true
        },
        {
          fieldName: 'procedures',
          text: 'Процедура',
          active: false,
          asc: true
        },                                 
      ]
    }),
    computed: {
      ...mapState("ListDT", ["currentSort"]),
      ...mapState("Auth", ["user"]),
      showStFilter() {
        return this.showStatusFilter === true ? '' : 'hidden'
      }
    },
    methods: {
      ...mapActions("ListDT", ["sortList"]),
      sortData(index) {
        if (this.sortColumns[index].active) {
          this.sortColumns[index].asc = !this.sortColumns[index].asc
        }
        if (!this.sortColumns[index].active) {
          this.sortColumns.map((col) => {
            col.active = false
            col.asc = true
          })
          this.sortColumns[index].active = true;
        }
        const sort = {
          field: this.sortColumns[index].fieldName,
          asc: this.sortColumns[index].asc
        }
        this.sortList(sort)
      }
    }
  }
</script>